import {apiCaller} from '@repo/shared/api/core/api_call';
import {FORBIDDEN_CODE} from '@repo/shared/api/core/api_errors';

import {setUser} from '@repo/website-frontend/stores/user_store';

export const apiCall = apiCaller('website_backend', fetch, console.error, {
  schemaValidation: false,
  onHttpError: (statusCode: number) => {
    if (statusCode === FORBIDDEN_CODE) {
      setUser(undefined);
    }
  },
});
